var _style, _circle, _polygon, _polygon2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _polygon3, _polygon4, _polygon5, _polygon6, _g, _g2, _g3, _g4, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path, _circle10, _circle11, _circle12, _circle13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg19(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#17243F;}\r\n\t.st2{fill:#CADADD;}\r\n\t.st3{fill:url(#SVGID_1_);}\r\n\t.st4{fill:url(#SVGID_2_);}\r\n\t.st5{fill:url(#SVGID_3_);}\r\n\t.st6{fill:url(#SVGID_4_);}\r\n\t.st7{fill:url(#SVGID_5_);}\r\n\t.st8{fill:url(#SVGID_6_);}\r\n\t.st9{fill:url(#SVGID_7_);}\r\n\t.st10{fill:url(#SVGID_8_);}\r\n\t.st11{fill:#17A7AF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 30,
    cy: 30,
    r: 30
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "39.5,9.7 34.5,10.8 33.9,10.9 33.9,7.9 34.5,8.1  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "34.5,8.1 34.5,10.8 33.9,10.9 33.9,7.9  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 15.8,
    className: "st0",
    width: 3.7,
    height: 1.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8,
    y: 19.5,
    className: "st0",
    width: 5.8,
    height: 2.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 24.2,
    className: "st0",
    width: 9.2,
    height: 2.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1,
    y: 28.9,
    className: "st0",
    width: 13,
    height: 2.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8,
    y: 33.6,
    className: "st0",
    width: 15.9,
    height: 2.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 38.3,
    className: "st0",
    width: 19.2,
    height: 2.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 43,
    className: "st0",
    width: 22.6,
    height: 2.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.36,
    y1: 2.03,
    x2: 31.36,
    y2: 49.26,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1,
    y: 17.6,
    className: "st3",
    width: 4.5,
    height: 2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.87,
    y1: 2.03,
    x2: 29.87,
    y2: 49.26,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1,
    y: 21.9,
    className: "st4",
    width: 7.5,
    height: 2.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.185,
    y1: 2.03,
    x2: 28.185,
    y2: 49.26,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 26.6,
    className: "st5",
    width: 10.8,
    height: 2.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.745,
    y1: 2.03,
    x2: 26.745,
    y2: 49.26,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 19.4,
    y: 31.3,
    className: "st6",
    width: 14.6,
    height: 2.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.84,
    y1: 2.03,
    x2: 24.84,
    y2: 49.26,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 35.9,
    className: "st7",
    width: 17.5,
    height: 2.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.165,
    y1: 2.03,
    x2: 23.165,
    y2: 49.26,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7,
    y: 40.6,
    className: "st8",
    width: 20.9,
    height: 2.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.545,
    y1: 2.03,
    x2: 21.545,
    y2: 49.26,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "33.7,47.3 28.8,47.6 9.4,47.7 9.4,45.3 33.6,45.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.29,
    y1: 9.45,
    x2: 39.29,
    y2: 45.36,
    gradientTransform: "matrix(1 0 0 -1 0 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16F7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21BBEE"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "50.6,43.5 42.6,46.8 28,47.7 31.4,43.8 28.5,38.3 34.5,31.7 30.7,26.6 33.8,16.2 33.9,15.8  34.8,15.8  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "50.6,43.5 42.6,46.8 39.8,39 39.5,31.4 38.5,26.3 35.8,23.1 34.7,19.5 34.3,15.8 34.8,15.8  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "16.4,51 27.9,47.4 27.8,47.5 31.1,43.6 31.1,43.9 28.2,38.4 28.1,38.2 28.2,38.1 34.2,31.5  34.2,31.9 30.5,26.7 30.4,26.6 30.5,26.5 33.7,15.7 34.1,15.8 31,26.6 30.9,26.4 34.7,31.5 34.8,31.7 34.7,31.9 28.6,38.5  28.7,38.2 31.6,43.7 31.7,43.8 31.6,44 28.1,47.8 28.1,47.9 28,47.9 16.5,51.5  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 34.8,
    cy: 32.1,
    r: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 28.8,
    cy: 38.7,
    r: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 31.5,
    cy: 44.3,
    r: 1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 31,
    cy: 26.9,
    r: 1
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 28.4,
    cy: 38.3,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 28.4,
    cy: 38.3,
    r: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 31.2,
    cy: 43.8,
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 31.2,
    cy: 43.8,
    r: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.8,
    cy: 47.7,
    r: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.8,
    cy: 47.7,
    r: 0.6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 16.5,
    cy: 51.3,
    r: 1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 16.5,
    cy: 51.3,
    r: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34,7.8l0.1,8c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0l0,0l0.1-8c0-0.1,0-0.1,0.1-0.1 c0,0,0,0,0,0C33.9,7.7,34,7.7,34,7.8z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34.5,
    cy: 31.7,
    r: 1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34.5,
    cy: 31.7,
    r: 0.6
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 30.7,
    cy: 26.6,
    r: 1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 30.7,
    cy: 26.6,
    r: 0.6
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg19);
export default __webpack_public_path__ + "static/media/19.b827af597eb573a92ef50ff4c0571be1.svg";
export { ForwardRef as ReactComponent };